import { SizesProvider } from '@/state/sizesProvider';

import { HomePlanFilteredGrid } from './data-wrappers/HomePlanFilteredGrid';
import { OrFilteredGridServer } from './or-filtered-grid.server';
import { IOrFilteredGridPropsCS } from './or-filtered-grid.types';

export const OrFilteredGridCMS = ({ block }: IOrFilteredGridPropsCS) => {
  const {
    _content_type_uid: contentType,
    filter_type: filterType,
    price_tooltip_text: tooltipText,
  } = block;

  return (
    <SizesProvider contentType={contentType}>
      {filterType === 'homePlans' && (
        <>
          <HomePlanFilteredGrid tooltipText={tooltipText} />
          <OrFilteredGridServer />
        </>
      )}
    </SizesProvider>
  );
};
